export enum ApiErrorCode {
    InternalServerError = 'internal_server_error',
}
